import { styled, Box } from '@mui/material';

export const LoadingFallbackContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  flex: 1,
});
